<div class="content-info">
  <div class="content-title">
    <h3 class="title">MBQ</h3>
    <div class="title-actions">
      <div class="form-group">
        <select class="form-control" [(ngModel)]="selectedLocation" (change)="onLocationChange()">
          <option [ngValue]="null" disabled>---Select Location---</option>
          @for (location of locations; track location) {
          <option [value]="location.id">
            {{ location.name }}
          </option>
          }
        </select>
      </div>

      <div class="form-group">
        <input type="text" [(ngModel)]="searchTerm" (input)="onSearch()" placeholder="Search Product"
          class="form-control" />
      </div>
      <!-- <button
        class="btn btnprimary"
        [routerLink]="['/mbq/create-mbq']"
        >
        <i class="bi bi-plus-lg"></i>Create MBQ
      </button> -->
    </div>
  </div>
  <div class="add-section mb-4 p-3 border rounded">
    <div class="row g-3 align-items-end">
      <div class="col-md-3 form-group position-relative">
        <label class="form-label">Search & Add Product</label>
        <ng-select [items]="products" bindLabel="longDescription" [typeahead]="productSearch$"
          [(ngModel)]="selectedProduct" [ngModelOptions]="{ standalone: true }" placeholder="Type to search product"
          [virtualScroll]="true" [searchFn]="customSearchFn">
          <ng-template ng-label-tmp let-item="item">
            {{ item.longDescription || item.skuCode }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.longDescription || item.skuCode }}
          </ng-template>
        </ng-select>
      </div>

      <div class="col-md-1 form-group">
        <label class="form-label">Reorder Level (min)</label>
        <input type="number" class="form-control" [(ngModel)]="reorderLevel" placeholder="Enter min level" />
      </div>

      <div class="col-md-1 form-group">
        <label class="form-label">MBQ (max)</label>
        <input type="number" class="form-control" [(ngModel)]="mbq" placeholder="Enter max quantity" />
      </div>

      <div class="col-md-1 d-grid">
        <button class="btn btn-success" (click)="addMbq()">Add</button>
      </div>

      <!-- <div class="col-md-4 form-group">
            <label class="form-label">Upload Excel</label>
            <app-excel-upload
          [uploadUrl]="
            baseUrl + '/replenishment/configs/upload/store-replenishment'
          "
              (uploadSuccess)="handleUploadSuccess($event)"
              (uploadError)="handleUploadError($event)"
            ></app-excel-upload>
          </div> -->
    </div>
  </div>
  <div class="common-table">
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>SKU</th>
            <th>Product</th>
            <th>Reorder Level</th>
            <th>MBQ</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @for (item of mbqList; track item) {
          <tr>
            <td>{{ item.sku || item?.variant?.product?.sku }}</td>
            <td>{{ item.productName }}</td>
            <!-- Reorder Level -->
            @if (editRowId !== item.id) {
            <td>{{ item.reorderLevel }}</td>
            }
            @if (editRowId === item.id) {
            <td>
              <input type="number" [(ngModel)]="editReorderLevel" class="form-control" />
            </td>
            }
            <!-- MBQ -->
            @if (editRowId !== item.id) {
            <td>{{ item.mbq }}</td>
            }
            @if (editRowId === item.id) {
            <td>
              <input type="number" [(ngModel)]="editMbq" class="form-control" />
            </td>
            }
            <!-- Action buttons -->
            <td>
              @if (editRowId !== item.id) {
              <button class="btn btn-sm btn-primary" (click)="startEdit(item)">
                Edit
              </button>
              }
              @if (editRowId === item.id) {
              <button class="btn btn-sm btn-success me-2" (click)="saveEdit(item)">
                ✅
              </button>
              }
              @if (editRowId === item.id) {
              <button class="btn btn-sm btn-secondary" (click)="cancelEdit()">
                ❌
              </button>
              }
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>

    <app-pagination [page]="currentPage" [limit]="pageSize" [pageCount]="pageCount"
      (pageChange)="goToPage($event)" (limitChange)="onPageSizeChange($event)">
    </app-pagination>
    @if (mbqList?.length) {
    <div class="d-flex justify-content-end mt-3">
      <button class="btn btnprimary" (click)="saveMbq()">Save MBQ</button>
    </div>
    }
  </div>
</div>